import { render, staticRenderFns } from "./redeem-dialog.vue?vue&type=template&id=c01adb8c&scoped=true&"
import script from "./redeem-dialog.vue?vue&type=script&lang=js&"
export * from "./redeem-dialog.vue?vue&type=script&lang=js&"
import style0 from "./redeem-dialog.vue?vue&type=style&index=0&id=c01adb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01adb8c",
  null
  
)

export default component.exports